import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "computerWithScheme",
    iconColor: "white",
    text: "Single pane of glass \nvisualization",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "gearWithSchema",
    iconColor: "white",
    text: "Manager of manager overlaying network\n assurance and inventory\n systems",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerFocusingPerson",
    iconColor: "white",
    text: "Persona based\n configurable \ndashboards",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_ISNA_1 = {
  title: "Observability",
  titleNumber: "1.",
  subtitle:
    "Converged observability platform for network and\n service operations.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  styleListData: { marginTop: "80px" },
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ENG_203"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_201"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_Introduction_02.png",
  modalImages: [
    "ENG/ISNA/modal/ISNA_MODAL_observe_1.png",
    "ENG/ISNA/modal/ISNA_MODAL_observe_2.png",
    "ENG/ISNA/modal/ISNA_MODAL_observe_3.png",
    "ENG/ISNA/modal/ISNA_MODAL_observe_4.png",
    "ENG/ISNA/modal/ISNA_MODAL_observe_5.png",
    "ENG/ISNA/modal/ISNA_MODAL_observe_6.png",
  ],
  showInfoButton: false,
  modalButton: "Observability demo",
};
